import { ContractsService } from "@/core/libs/api";

export async function getContract(contractId: number | string) {
  const abortController = new AbortController();
  const { signal } = abortController;

  const service = ContractsService();
  return service.get({ id: contractId.toString(), signal });
}
